// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://polygonscan.com/address/0xa97684ead0e402dC232d5A977953DF7ECBaB3CDb
export const POOL_ADDRESSES_PROVIDER = '0xa97684ead0e402dC232d5A977953DF7ECBaB3CDb';

// IPool https://polygonscan.com/address/0x794a61358D6845594F94dc1DB02A252b5b4814aD
export const POOL = '0x794a61358D6845594F94dc1DB02A252b5b4814aD';

// IPoolConfigurator https://polygonscan.com/address/0x8145eddDf43f50276641b55bd3AD95944510021E
export const POOL_CONFIGURATOR = '0x8145eddDf43f50276641b55bd3AD95944510021E';

// IAaveOracle https://polygonscan.com/address/0xb023e699F5a33916Ea823A16485e259257cA8Bd1
export const ORACLE = '0xb023e699F5a33916Ea823A16485e259257cA8Bd1';

// https://polygonscan.com/address/0xDf7d0e6454DB638881302729F5ba99936EaAB233
export const ACL_ADMIN = '0xDf7d0e6454DB638881302729F5ba99936EaAB233';

// IACLManager https://polygonscan.com/address/0xa72636CbcAa8F5FF95B2cc47F3CDEe83F3294a0B
export const ACL_MANAGER = '0xa72636CbcAa8F5FF95B2cc47F3CDEe83F3294a0B';

// IPoolDataProvider https://polygonscan.com/address/0x243Aa95cAC2a25651eda86e80bEe66114413c43b
export const AAVE_PROTOCOL_DATA_PROVIDER = '0x243Aa95cAC2a25651eda86e80bEe66114413c43b';

// https://polygonscan.com/address/0x9187A3DF029394A617f499E72728dA31Ba7891E5
export const POOL_IMPL = '0x9187A3DF029394A617f499E72728dA31Ba7891E5';

// https://polygonscan.com/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://polygonscan.com/address/0x929EC64c34a17401F460460D4B9390518E5B473e
export const DEFAULT_INCENTIVES_CONTROLLER = '0x929EC64c34a17401F460460D4B9390518E5B473e';

// https://polygonscan.com/address/0x048f2228D7Bf6776f99aB50cB1b1eaB4D1d4cA73
export const EMISSION_MANAGER = '0x048f2228D7Bf6776f99aB50cB1b1eaB4D1d4cA73';

// ICollector https://polygonscan.com/address/0xe8599F3cc5D38a9aD6F3684cd5CEa72f10Dbc383
export const COLLECTOR = '0xe8599F3cc5D38a9aD6F3684cd5CEa72f10Dbc383';

// https://polygonscan.com/address/0xE91da59375C7214cB880af71Ad50f195C33C5981
export const DEFAULT_A_TOKEN_IMPL = '0xE91da59375C7214cB880af71Ad50f195C33C5981';

// https://polygonscan.com/address/0xC0442C25FE517ac37D6a0D485446307D97d24712
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0xC0442C25FE517ac37D6a0D485446307D97d24712';

// https://polygonscan.com/address/0x1e0A5985D58B45C38598e293189aa5228054629b
export const RISK_STEWARD = '0x1e0A5985D58B45C38598e293189aa5228054629b';

// https://polygonscan.com/address/0xE28E2c8d240dd5eBd0adcab86fbD79df7a052034
export const DEBT_SWAP_ADAPTER = '0xE28E2c8d240dd5eBd0adcab86fbD79df7a052034';

// https://polygonscan.com/address/0xB2617F48dab4E5FCa387C6D7Ba69172c23A230Ba
export const CONFIG_ENGINE = '0xB2617F48dab4E5FCa387C6D7Ba69172c23A230Ba';

// https://polygonscan.com/address/0x770ef9f4fe897e59daCc474EF11238303F9552b6
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0x770ef9f4fe897e59daCc474EF11238303F9552b6';

// https://polygonscan.com/address/0x5d4D4007A4c6336550DdAa2a7c0d5e7972eebd16
export const REPAY_WITH_COLLATERAL_ADAPTER = '0x5d4D4007A4c6336550DdAa2a7c0d5e7972eebd16';

// https://polygonscan.com/address/0x397202AB0b4E7C954ac0c493c00749C517210953
export const LEGACY_STATIC_A_TOKEN_FACTORY = '0x397202AB0b4E7C954ac0c493c00749C517210953';

// https://polygonscan.com/address/0xC4aff49fCeD8ac1D818a6DCAB063f9f97E66ec5E
export const SWAP_COLLATERAL_ADAPTER = '0xC4aff49fCeD8ac1D818a6DCAB063f9f97E66ec5E';

// https://polygonscan.com/address/0x91E04cf78e53aEBe609e8a7f2003e7EECD743F2B
export const UI_INCENTIVE_DATA_PROVIDER = '0x91E04cf78e53aEBe609e8a7f2003e7EECD743F2B';

// https://polygonscan.com/address/0xFa1A7c4a8A63C9CAb150529c26f182cBB5500944
export const UI_POOL_DATA_PROVIDER = '0xFa1A7c4a8A63C9CAb150529c26f182cBB5500944';

// https://polygonscan.com/address/0xBc790382B3686abffE4be14A030A96aC6154023a
export const WALLET_BALANCE_PROVIDER = '0xBc790382B3686abffE4be14A030A96aC6154023a';

// https://polygonscan.com/address/0xBC302053db3aA514A3c86B9221082f162B91ad63
export const WETH_GATEWAY = '0xBC302053db3aA514A3c86B9221082f162B91ad63';

// https://polygonscan.com/address/0x78F8Bd884C3D738B74B420540659c82f392820e0
export const WITHDRAW_SWAP_ADAPTER = '0x78F8Bd884C3D738B74B420540659c82f392820e0';

// https://polygonscan.com/address/0x2797F0BCff7b76c0439EC82018cD8011909bA812
export const DUST_BIN = '0x2797F0BCff7b76c0439EC82018cD8011909bA812';

// https://polygonscan.com/address/0x476B3D5509f600cC377Ab86658b623337Fc6A717
export const CLINIC_STEWARD = '0x476B3D5509f600cC377Ab86658b623337Fc6A717';

// https://polygonscan.com/address/0xE5b11ab4D36E58C9171e3DB98Ba17336606Cd6ef
export const POOL_EXPOSURE_STEWARD = '0xE5b11ab4D36E58C9171e3DB98Ba17336606Cd6ef';

// https://polygonscan.com/address/0x1504F1d7b6892600ae0d394F9042e696dd9F87Fa
export const STATA_FACTORY = '0x1504F1d7b6892600ae0d394F9042e696dd9F87Fa';

// https://polygonscan.com/address/0x9f6aA2aB14bFF53e4b79A81ce1554F1DFdbb6608
export const EDGE_RISK_ORACLE = '0x9f6aA2aB14bFF53e4b79A81ce1554F1DFdbb6608';

// https://polygonscan.com/address/0x35B09a414F6003346cA2E2553b3ea91Cd3524af3
export const EDGE_RISK_STEWARD_CAPS = '0x35B09a414F6003346cA2E2553b3ea91Cd3524af3';

// https://polygonscan.com/address/0x54714FAc85b0bf627288CC3a186dE81A42f1D635
export const EDGE_INJECTOR_CAPS = '0x54714FAc85b0bf627288CC3a186dE81A42f1D635';

export const CHAIN_ID = 137;
export const ASSETS = {
  DAI: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    A_TOKEN: '0x82E64f49Ed5EC1bC6e43DAD4FC8Af9bb3A2312EE',
    V_TOKEN: '0x8619d80FB0141ba7F184CbF22fd724116D9f7ffC',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0xa1913Df228db08F02F3F3Dc0f397Af3A2d2f96A1',
    STATIC_A_TOKEN: '0x83c59636e602787A6EEbBdA2915217B416193FcB',
  },
  LINK: {
    decimals: 18,
    id: 1,
    UNDERLYING: '0x53E0bca35eC356BD5ddDFebbD1Fc0fD03FaBad39',
    A_TOKEN: '0x191c10Aa4AF7C30e871E70C95dB0E4eb77237530',
    V_TOKEN: '0x953A573793604aF8d41F306FEb8274190dB4aE0e',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0xd9FFdb71EbE7496cC440152d43986Aae0AB76665',
    STATIC_A_TOKEN: '0x37868a45c6741616F9E5a189dC0481AD70056B6a',
  },
  USDC: {
    decimals: 6,
    id: 2,
    UNDERLYING: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    A_TOKEN: '0x625E7708f30cA75bfd92586e17077590C60eb4cD',
    V_TOKEN: '0xFCCf3cAbbe80101232d343252614b6A3eE81C989',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0x31Ebeb03223AaC82C8EB24C77624Ea40F4D849Fb',
    STATIC_A_TOKEN: '0x1017F4a86Fc3A3c824346d0b8C5e96A5029bDAf9',
    STATA_TOKEN: '0xE1a9178Ad1815099004145eC00Eb516B54c93CEB',
  },
  WBTC: {
    decimals: 8,
    id: 3,
    UNDERLYING: '0x1BFD67037B42Cf73acF2047067bd4F2C47D9BfD6',
    A_TOKEN: '0x078f358208685046a11C85e8ad32895DED33A249',
    V_TOKEN: '0x92b42c66840C7AD907b4BF74879FF3eF7c529473',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0xc907E116054Ad103354f2D350FD2514433D57F6f',
    STATIC_A_TOKEN: '0xbC0f50CCB8514Aa7dFEB297521c4BdEBc9C7d22d',
  },
  WETH: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
    A_TOKEN: '0xe50fA9b3c56FfB159cB0FCA61F5c9D750e8128c8',
    V_TOKEN: '0x0c84331e39d6658Cd6e6b9ba04736cC4c4734351',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0xF9680D99D6C9589e2a93a78A04A279e509205945',
    STATIC_A_TOKEN: '0xb3D5Af0A52a35692D3FcbE37669b3B8C31dddE7D',
  },
  USDT0: {
    decimals: 6,
    id: 5,
    UNDERLYING: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    A_TOKEN: '0x6ab707Aca953eDAeFBc4fD23bA73294241490620',
    V_TOKEN: '0xfb00AC187a8Eb5AFAE4eACE434F493Eb62672df7',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0x01Aba1Fe7D72a3490bEef7CD0C09e1Ba2dD88D83',
    STATIC_A_TOKEN: '0x87A1fdc4C726c459f597282be639a045062c0E46',
    STATA_TOKEN: '0x2eaD203C5C1C00612B1DdbBb20e4180dA822d6ff',
  },
  AAVE: {
    decimals: 18,
    id: 6,
    UNDERLYING: '0xD6DF932A45C0f255f85145f286eA0b292B21C90B',
    A_TOKEN: '0xf329e36C7bF6E5E86ce2150875a84Ce77f477375',
    V_TOKEN: '0xE80761Ea617F66F96274eA5e8c37f03960ecC679',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0x72484B12719E23115761D5DA1646945632979bB6',
    STATIC_A_TOKEN: '0xCA2E1E33E5BCF4978E2d683656E1f5610f8C4A7E',
  },
  WPOL: {
    decimals: 18,
    id: 7,
    UNDERLYING: '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
    A_TOKEN: '0x6d80113e533a2C0fe82EaBD35f1875DcEA89Ea97',
    V_TOKEN: '0x4a1c3aD6Ed28a636ee1751C69071f6be75DEb8B8',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0xAB594600376Ec9fD91F8e885dADF0CE036862dE0',
    STATIC_A_TOKEN: '0x98254592408E389D1dd2dBa318656C2C5c305b4E',
  },
  CRV: {
    decimals: 18,
    id: 8,
    UNDERLYING: '0x172370d5Cd63279eFa6d502DAB29171933a610AF',
    A_TOKEN: '0x513c7E3a9c69cA3e22550eF58AC1C0088e918FFf',
    V_TOKEN: '0x77CA01483f379E58174739308945f044e1a764dc',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0x336584C8E6Dc19637A5b36206B1c79923111b405',
    STATIC_A_TOKEN: '0x4356941463eD4d75381AC23C9EF799B5d7C52AD8',
  },
  SUSHI: {
    decimals: 18,
    id: 9,
    UNDERLYING: '0x0b3F868E0BE5597D5DB7fEB59E1CADBb0fdDa50a',
    A_TOKEN: '0xc45A479877e1e9Dfe9FcD4056c699575a1045dAA',
    V_TOKEN: '0x34e2eD44EF7466D5f9E0b782B5c08b57475e7907',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0x49B0c695039243BBfEb8EcD054EB70061fd54aa0',
    STATIC_A_TOKEN: '0xe3eDe71d32240b7EC355F0e5DD1131BBe029F934',
  },
  GHST: {
    decimals: 18,
    id: 10,
    UNDERLYING: '0x385Eeac5cB85A38A9a07A70c73e0a3271CfB54A7',
    A_TOKEN: '0x8Eb270e296023E9D92081fdF967dDd7878724424',
    V_TOKEN: '0xCE186F6Cccb0c955445bb9d10C59caE488Fea559',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0xDD229Ce42f11D8Ee7fFf29bDB71C7b81352e11be',
    STATIC_A_TOKEN: '0x123319636A6a9c85D9959399304F4cB23F64327e',
  },
  BAL: {
    decimals: 18,
    id: 11,
    UNDERLYING: '0x9a71012B13CA4d3D0Cdc72A177DF3ef03b0E76A3',
    A_TOKEN: '0x8ffDf2DE812095b1D19CB146E4c004587C0A0692',
    V_TOKEN: '0xA8669021776Bc142DfcA87c21b4A52595bCbB40a',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0xD106B538F2A868c28Ca1Ec7E298C3325E0251d66',
    STATIC_A_TOKEN: '0x1a8969FD39AbaF228e690B172C4C3Eb7c67F95E1',
  },
  DPI: {
    decimals: 18,
    id: 12,
    UNDERLYING: '0x85955046DF4668e1DD369D2DE9f3AEB98DD2A369',
    A_TOKEN: '0x724dc807b04555b71ed48a6896b6F41593b8C637',
    V_TOKEN: '0xf611aEb5013fD2c0511c9CD55c7dc5C1140741A6',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0x105fe43207CE8331555C9Be8c13718d6DeD2fD97',
    STATIC_A_TOKEN: '0x73B788ACA5f4F0EeB3c6Da453cDf31041a77b36D',
  },
  EURS: {
    decimals: 2,
    id: 13,
    UNDERLYING: '0xE111178A87A3BFf0c8d18DECBa5798827539Ae99',
    A_TOKEN: '0x38d693cE1dF5AaDF7bC62595A37D667aD57922e5',
    V_TOKEN: '0x5D557B07776D12967914379C71a1310e917C7555',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0x73366Fe0AA0Ded304479862808e02506FE556a98',
    STATIC_A_TOKEN: '0x02E26888Ed3240BB38f26A2adF96Af9B52b167ea',
  },
  jEUR: {
    decimals: 18,
    id: 14,
    UNDERLYING: '0x4e3Decbb3645551B8A19f0eA1678079FCB33fB4c',
    A_TOKEN: '0x6533afac2E7BCCB20dca161449A13A32D391fb00',
    V_TOKEN: '0x44705f578135cC5d703b4c9c122528C73Eb87145',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0x73366Fe0AA0Ded304479862808e02506FE556a98',
    STATIC_A_TOKEN: '0xD992DaC78Ef3F34614E6a7d325b7b6A320FC0AB5',
  },
  EURA: {
    decimals: 18,
    id: 15,
    UNDERLYING: '0xE0B52e49357Fd4DAf2c15e02058DCE6BC0057db4',
    A_TOKEN: '0x8437d7C167dFB82ED4Cb79CD44B7a32A1dd95c77',
    V_TOKEN: '0x3ca5FA07689F266e907439aFd1fBB59c44fe12f6',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0x73366Fe0AA0Ded304479862808e02506FE556a98',
    STATIC_A_TOKEN: '0xd3eb8796Ed36f58E03B7b4b5AD417FA74931d2c4',
  },
  miMATIC: {
    decimals: 18,
    id: 16,
    UNDERLYING: '0xa3Fa99A148fA48D14Ed51d610c367C61876997F1',
    A_TOKEN: '0xeBe517846d0F36eCEd99C735cbF6131e1fEB775D',
    V_TOKEN: '0x18248226C16BF76c032817854E7C83a2113B4f06',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0x1e2Ba4725c6847dC8304466c4eA25A872A7D43a8',
    STATIC_A_TOKEN: '0x8486B49433cCed038b51d18Ae3772CDB7E31CA5e',
  },
  stMATIC: {
    decimals: 18,
    id: 17,
    UNDERLYING: '0x3A58a54C066FdC0f2D55FC9C89F0415C92eBf3C4',
    A_TOKEN: '0xEA1132120ddcDDA2F119e99Fa7A27a0d036F7Ac9',
    V_TOKEN: '0x6b030Ff3FB9956B1B69f475B77aE0d3Cf2CC5aFa',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0x6D02E35031C4D99ee3A6A2BA47FaD0cFE355cA8f',
    STATIC_A_TOKEN: '0x867A180B7060fDC27610dC9096E93534F638A315',
  },
  MaticX: {
    decimals: 18,
    id: 18,
    UNDERLYING: '0xfa68FB4628DFF1028CFEc22b4162FCcd0d45efb6',
    A_TOKEN: '0x80cA0d8C38d2e2BcbaB66aA1648Bd1C7160500FE',
    V_TOKEN: '0xB5b46F918C2923fC7f26DB76e8a6A6e9C4347Cf9',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0xB0A72A5e454890e9715e059e8df8582a6B383DE3',
    STATIC_A_TOKEN: '0xbcDd5709641Af4BE99b1470A2B3A5203539132Ec',
  },
  wstETH: {
    decimals: 18,
    id: 19,
    UNDERLYING: '0x03b54A6e9a984069379fae1a4fC4dBAE93B3bCCD',
    A_TOKEN: '0xf59036CAEBeA7dC4b86638DFA2E3C97dA9FcCd40',
    V_TOKEN: '0x77fA66882a8854d883101Fb8501BD3CaD347Fc32',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0xBD96b5ABBC6048c28184b462167E487533F2e35E',
    STATIC_A_TOKEN: '0x5274453F4CD5dD7280011a1Cca3B9e1b78EC59A6',
  },
  USDCn: {
    decimals: 6,
    id: 20,
    UNDERLYING: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
    A_TOKEN: '0xA4D94019934D8333Ef880ABFFbF2FDd611C762BD',
    V_TOKEN: '0xE701126012EC0290822eEA17B794454d1AF8b030',
    INTEREST_RATE_STRATEGY: '0x56076f960980d453b5B749CB6A1c4D2E4e138B1A',
    ORACLE: '0x31Ebeb03223AaC82C8EB24C77624Ea40F4D849Fb',
    STATIC_A_TOKEN: '0x2dCa80061632f3F87c9cA28364d1d0c30cD79a19',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'DAI,USDC,USDT0,EURS,jEUR,EURA,miMATIC,USDCn / ',
    collateralBitmap: '1171493',
    collateralAssets: [
      '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
      '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
      '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
      '0xE111178A87A3BFf0c8d18DECBa5798827539Ae99',
      '0x4e3Decbb3645551B8A19f0eA1678079FCB33fB4c',
      '0xE0B52e49357Fd4DAf2c15e02058DCE6BC0057db4',
      '0xa3Fa99A148fA48D14Ed51d610c367C61876997F1',
      '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
    ],
    borrowableBitmap: '0',
    borrowableAssets: [],
    ltvzeroBitmap: '122885',
    ltvzeroAssets: [
      '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
      '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
      '0xE111178A87A3BFf0c8d18DECBa5798827539Ae99',
      '0x4e3Decbb3645551B8A19f0eA1678079FCB33fB4c',
      '0xE0B52e49357Fd4DAf2c15e02058DCE6BC0057db4',
      '0xa3Fa99A148fA48D14Ed51d610c367C61876997F1',
    ],
    ltv: 9125,
    liquidationThreshold: 9425,
    liquidationBonus: 10100,
  },
  '2': {
    label: 'WPOL,stMATIC,MaticX / WPOL',
    collateralBitmap: '393344',
    collateralAssets: [
      '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270',
      '0x3A58a54C066FdC0f2D55FC9C89F0415C92eBf3C4',
      '0xfa68FB4628DFF1028CFEc22b4162FCcd0d45efb6',
    ],
    borrowableBitmap: '128',
    borrowableAssets: ['0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270'],
    ltvzeroBitmap: '131072',
    ltvzeroAssets: ['0x3A58a54C066FdC0f2D55FC9C89F0415C92eBf3C4'],
    ltv: 9250,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '3': {
    label: 'WETH,wstETH / WETH',
    collateralBitmap: '524304',
    collateralAssets: [
      '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619',
      '0x03b54A6e9a984069379fae1a4fC4dBAE93B3bCCD',
    ],
    borrowableBitmap: '16',
    borrowableAssets: ['0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9300,
    liquidationBonus: 10100,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
